define(['modules/common/controls/control', 'utils/search/filterSearch'], (Control, filterSearch) => Control.extend({

    tagName: 'input',
    attributes: {type: 'text'},

    events: {
        change: 'removeErrors'
    },

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    let val = view.$el.val();
                    if (view.options.cleardanglingspaces) {
                        val = filterSearch.default(val);
                    }
                    publish(val);
                };
                view.$el.on('change', this.callback);
            },
            unbind (view) {
                view.$el.off('change', this.callback);
            },
            routine (view, value) {
                view.$el.val(value);
            }
        },
        enabled (view, value) {
            view.$el.attr('disabled', !value);
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        },
        readonly (view, value) {
            view.$el.attr('readonly', value);
        }
    },

    render () {
        if (this.options.autofocus) {
            this.$el.attr({autofocus: 'autofocus'});
        }
        if (this.options.placeholder) {
            this.$el.attr({placeholder: this.options.placeholder});
        }
        if (this.options.width) {
            this.$el.css({width: this.options.width});
        }
        return Control.prototype.render.apply(this, arguments);
    }
}));
